import PropTypes from 'prop-types';
import React from 'react';
import { useTheme } from 'styled-components';
import ButtonV2 from 'components/ButtonV2';
import { Icon, inkA, tokens } from 'components/v3';

// Shown under the header while the form is archived (both layouts): the
// builder is read-only until it's restored.
const ArchivedBanner = ({ onRestore, busy }) => {
  const theme = useTheme();
  const t = tokens(theme);
  return (
    <div
      role="status"
      style={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 12,
        padding: '12px 16px',
        marginBottom: 16,
        borderRadius: 12,
        border: '1px solid ' + t.border,
        background: inkA(theme, 0.05),
        color: t.sub,
        fontSize: 14,
      }}
    >
      <Icon name="archive" size={18} color="currentColor" />
      <span style={{ flex: '1 1 220px', minWidth: 0 }}>
        This form is archived. Restore it to make changes.
      </span>
      <ButtonV2
        primary
        disabled={busy}
        onClick={onRestore}
        icon={<Icon name="archive-restore" size={15} color="currentColor" />}
      >
        {busy ? 'Restoring…' : 'Restore'}
      </ButtonV2>
    </div>
  );
};

ArchivedBanner.propTypes = {
  onRestore: PropTypes.func.isRequired,
  busy: PropTypes.bool,
};

ArchivedBanner.defaultProps = { busy: false };

export default ArchivedBanner;
